// extracted by mini-css-extract-plugin
export default {"starRatingContainer":"H_cp","starItem":"H_cz","fullStar":"H_cq","halfStar":"H_cB","emptyStar":"H_cC","inactive":"H_k"};